import {showFailToast} from "vant";

const ERROR_CODES = {
    CAPTCHA_ERROR: -105,
    VERIFY_ERROR : 1006,
    SERVER_ERROR:-500,
    CARD_SERVER_ERROR:1080,
    CAPTCHA_EXPIRED: 33008,
    CAPTCHA_NOTFOUND: 33004,
    PASSWORD_ERROR: 629,
    USERNAME_NOT_FOUND: 626,
    LOGIN_TIMEOUT: 662,
    EXIST_ERROR:1005,
    EXPIRE_ERROR:1007,
    CARD_ERROR : 1004,
    ENOUGH_ERROR:-1,
    PARAM_ERROR:5000003,
    USERID_REPEATED_ERROR:94001, //用户名已被注册
    EMAIL_REPEATED_ERROR:94002, //邮箱已被注册
};

const handleError = (code, ref) => {
    switch (code) {
        case ERROR_CODES.VERIFY_ERROR:
        case ERROR_CODES.CAPTCHA_ERROR:
        case ERROR_CODES.CAPTCHA_NOTFOUND:
            showFailAndRefreshCaptcha("验证码错误。。。", ref);
            break;
        case ERROR_CODES.CAPTCHA_EXPIRED:
            showFailAndRefreshCaptcha("验证码过期。。。", ref);
            break;
        case ERROR_CODES.USERID_REPEATED_ERROR:
            showFailAndRefreshCaptcha("用户名已被注册。。。", ref);
            break;
        case ERROR_CODES.EMAIL_REPEATED_ERROR:
            showFailAndRefreshCaptcha("邮箱已被注册。。。", ref);
            break;
        case ERROR_CODES.PASSWORD_ERROR:
            showFailAndRefreshCaptcha("密码错误。。。", ref);
            break;
        case ERROR_CODES.USERNAME_NOT_FOUND:
            showFailAndRefreshCaptcha("用户名不存在。。。", ref);
            break;
        case ERROR_CODES.LOGIN_TIMEOUT:
            showFailAndRefreshCaptcha("登录超时。。。", ref);
            break;
        case ERROR_CODES.PARAM_ERROR:
            showFailAndRefreshCaptcha("请求参数出错啦。。。", ref);
            break;
        case ERROR_CODES.ENOUGH_ERROR:
            showFailAndRefreshCaptcha("余额不足请充值。。。", ref);
            break;
        case ERROR_CODES.SERVER_ERROR:
        case ERROR_CODES.CARD_SERVER_ERROR:
            showFailAndRefreshCaptcha("服务器错误！请联系管理员或，稍后再次尝试", ref);
            break;
        case ERROR_CODES.CARD_ERROR:
            showFailAndRefreshCaptcha("卡号密码错误。买错卡的请发邮件联系管理员手动充值", ref);
            break;
        case ERROR_CODES.EXIST_ERROR:
        case ERROR_CODES.EXPIRE_ERROR:
            showFailAndRefreshCaptcha("该卡号已被使用", ref);
            break;
        default:
            console.log(code);
            showFailToast("服务器错误！！联系管理员");
    }
}
const showFailAndRefreshCaptcha = (message, ref) => {
    showFailToast({
        message:message,
    });
    setTimeout(() => {
        if (ref) {
            ref.timestamp = 0;
            ref.refreshCaptcha();
        }
    }, 0);
}
const copyToClipboard = async (text)=>{
    try {
        await navigator.clipboard.writeText(text);
        showFailToast({
            message:"复制成功",
        });
    } catch (err) {
        console.error("复制失败：", err);
        showFailToast({
            message:"复制失败稍后尝试",
        });
    }
}
export {
    handleError,
    copyToClipboard
}
